import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import typography from "assets/theme/base/typography";

function Footer({ light }) {
  const { size } = typography;

  return (
    <MDBox position="absolute" width="100%" bottom={0} py={4}>
      <Container>
        <MDBox display="flex" justifyContent="center" alignItems="center" flexWrap="wrap" color={light ? "white" : "text"} fontSize={size.sm}>
          &copy; {new Date().getFullYear()}, made with
          <MDBox fontSize={size.md} color={light ? "white" : "dark"} mb={-0.5} mx={0.25}>
            <Icon color="inherit" fontSize="inherit">favorite</Icon>
          </MDBox>
          by
          <MDTypography variant="button" fontWeight="medium" color={light ? "white" : "dark"}>
            &nbsp;GreenMango&nbsp;
          </MDTypography>
          for a better web.
        </MDBox>
      </Container>
    </MDBox>
  );
}

// Setting default props for the Footer
Footer.defaultProps = {
  light: false,
};

// Typechecking props for the Footer
Footer.propTypes = {
  light: PropTypes.bool,
};

export default Footer;
